<template>
    <div class="container">
        <div @click="goback" style="font-size:14px;margin-bottom:10px;cursor:pointer;width:50px">
            <i class="el-icon-back"></i>
            返回
        </div>
        <!-- 基本信息 -->
        <div class="section-header">
            <span class="section-title">设备信息</span>
            <div>
                <el-button v-if="!device.running" size="mini" class="btnClass"
                    style="background-color:#36C626;border-color:#36C626;" @click="startDevice">启动</el-button>
                <el-button v-if="device.running" size="mini" class="btnClass"
                    style="background-color:#FF9900;border-color:#FF9900;" @click="stopDevice">停止</el-button>
                <el-button size="mini" style="background-color:#FF1A2E;border-color:#FF1A2E;color:#FFF;"
                    @click="deleteDevice">删除</el-button>
            </div>
        </div>
        <div class="device-info">
            <el-row :gutter="16">
                <el-col :span="8">
                    <div class="info-item"><span class="info-label">UUID</span><span class="info-value">{{ device.uuid
                            }}</span></div>
                </el-col>
                <el-col :span="8">
                    <div class="info-item"><span class="info-label">设备ID</span><span class="info-value">{{
                        device.device_id }}</span></div>
                </el-col>
                <el-col :span="8">
                    <div class="info-item"><span class="info-label">产品型号</span><span class="info-value">{{
                        device.model_code }}</span></div>
                </el-col>
                <el-col :span="8">
                    <div class="info-item"><span class="info-label">绑定用户</span><span class="info-value">{{
                        device.owner_uid }}</span></div>
                </el-col>
                <el-col :span="8">
                    <div class="info-item"><span class="info-label">设备名称</span><span class="info-value">{{ device.name
                            }}</span></div>
                </el-col>
                <el-col :span="8">
                    <div class="info-item">
                        <span class="info-label">运行状态</span>
                        <span class="info-value" :style="{ color: device.running ? '#36C626' : '#FF1A2E' }">{{
                            device.running ? '运行中' : '已停止' }}</span>
                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="info-item">
                        <span class="info-label">MQTT连接</span>
                        <span class="info-value" :style="{ color: device.mqtt_connected ? '#36C626' : '#FF1A2E' }">{{
                            device.mqtt_connected ? '已连接' : '未连接' }}</span>
                    </div>
                </el-col>
            </el-row>
        </div>

        <!-- 属性设置 -->
        <div class="section-header" style="margin-top:24px">
            <span class="section-title">属性设置</span>
        </div>
        <div class="search">
            <el-form :model="propForm" label-width="100px" :inline="true" size="mini" class="demo-form-inline">
                <el-form-item label="开关：">
                    <el-select v-model="propForm.Switch" placeholder=" " clearable>
                        <el-option label="开" value="1"></el-option>
                        <el-option label="关" value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="工作模式：">
                    <el-select v-model="propForm.WorkMode" placeholder=" " clearable>
                        <el-option label="白光" value="0"></el-option>
                        <el-option label="彩光" value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="勿扰模式：">
                    <el-select v-model="propForm.DoNotDisturb" placeholder=" " clearable>
                        <el-option label="开启" value="1"></el-option>
                        <el-option label="关闭" value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="上电行为：">
                    <el-input v-model="propForm.PowerMemory" placeholder='{"M":0}' style="width:200px"></el-input>
                </el-form-item>
                <el-form-item label="HSV颜色：">
                    <el-input v-model="propForm.Color" placeholder='{"H":240,"S":90,"V":80}'
                        style="width:250px"></el-input>
                </el-form-item>
            </el-form>
            <el-form :model="propForm" label-width="100px" size="mini" class="slider-form">
                <el-row :gutter="24">
                    <el-col :span="8">
                        <el-form-item label="亮度：">
                            <div class="slider-wrap">
                                <el-slider v-model="propForm.BrightnessNum" :min="0" :max="100"></el-slider>
                                <span class="slider-val">{{ propForm.BrightnessNum }}</span>
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="彩光亮度：">
                            <div class="slider-wrap">
                                <el-slider v-model="propForm.ColorBrightnessNum" :min="0" :max="100"></el-slider>
                                <span class="slider-val">{{ propForm.ColorBrightnessNum }}</span>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="24">
                    <el-col :span="8">
                        <el-form-item label="色温：">
                            <div class="slider-wrap">
                                <el-slider v-model="propForm.ColorTempNum" :min="0" :max="100"></el-slider>
                                <span class="slider-val">{{ propForm.ColorTempNum }}</span>
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8" style="display:flex;align-items:center;padding-left:24px;">
                        <el-button type="primary" class="btnClass" @click="setProperties" :loading="propLoading"
                            :disabled="!device.running">下发属性</el-button>
                    </el-col>
                </el-row>
            </el-form>
        </div>

        <!-- 定时计划 -->
        <div class="section-header">
            <span class="section-title">定时计划</span>
            <el-button size="mini" class="btnClass" @click="loadSchedules">刷新</el-button>
        </div>
        <el-table :data="schedules" size="mini" empty-text="暂无定时计划">
            <el-table-column label="序号" prop="index" width="60"></el-table-column>
            <el-table-column label="时间">
                <template v-slot="scope">
                    <span>{{ padTime(scope.row.hour) }}:{{ padTime(scope.row.minute) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="重复">
                <template v-slot="scope">
                    <span>{{ formatRepeatDays(scope.row.repeatDays) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="标签" prop="tag"></el-table-column>
            <el-table-column label="动作">
                <template v-slot="scope">
                    <span v-if="scope.row.action === 0">关</span>
                    <span v-else-if="scope.row.action === 1">开</span>
                    <span v-else-if="scope.row.action === 2">开并调光</span>
                    <span v-else>{{ scope.row.action }}</span>
                </template>
            </el-table-column>
            <el-table-column label="目标属性" prop="targetAttrId"></el-table-column>
            <el-table-column label="工作模式">
                <template v-slot="scope">
                    <span v-if="scope.row.action === 2">{{ scope.row.workMode === 0 ? '白光' : '彩光' }}</span>
                    <span v-else>-</span>
                </template>
            </el-table-column>
            <el-table-column label="亮度" prop="brightness"></el-table-column>
            <el-table-column label="色温" prop="colorTemp"></el-table-column>
            <el-table-column label="色相" prop="hue"></el-table-column>
            <el-table-column label="饱和度" prop="saturation"></el-table-column>
            <el-table-column label="彩光亮度" prop="value"></el-table-column>
            <el-table-column label="通知">
                <template v-slot="scope">
                    <span style="color:#36C626" v-if="scope.row.notification">是</span>
                    <span style="color:#FF1A2E" v-else>否</span>
                </template>
            </el-table-column>
            <el-table-column label="启用">
                <template v-slot="scope">
                    <span style="color:#36C626" v-if="scope.row.enable">是</span>
                    <span style="color:#FF1A2E" v-else>否</span>
                </template>
            </el-table-column>
        </el-table>

        <!-- 唤醒计划 -->
        <div class="section-header" style="margin-top:24px">
            <span class="section-title">唤醒计划</span>
            <el-button size="mini" class="btnClass" @click="loadWakeupPlans">刷新</el-button>
        </div>
        <el-table :data="wakeupPlans" size="mini" empty-text="暂无唤醒计划">
            <el-table-column label="序号" prop="index" width="60"></el-table-column>
            <el-table-column label="时间">
                <template v-slot="scope">
                    <span>{{ padTime(scope.row.hour) }}:{{ padTime(scope.row.minute) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="重复">
                <template v-slot="scope">
                    <span>{{ formatRepeatDays(scope.row.repeatDays) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="标签" prop="tag"></el-table-column>
            <el-table-column label="渐亮时长(分)" prop="fadeDuration"></el-table-column>
            <el-table-column label="关灯">
                <template v-slot="scope">
                    <span style="color:#36C626" v-if="scope.row.lightOffEnable">是</span>
                    <span style="color:#FF1A2E" v-else>否</span>
                </template>
            </el-table-column>
            <el-table-column label="关灯延迟(分)" prop="lightOffDelay"></el-table-column>
            <el-table-column label="自定义">
                <template v-slot="scope">
                    <span style="color:#36C626" v-if="scope.row.customize">是</span>
                    <span style="color:#FF1A2E" v-else>否</span>
                </template>
            </el-table-column>
            <el-table-column label="自定义色相" prop="customHue"></el-table-column>
            <el-table-column label="自定义饱和度" prop="customSat"></el-table-column>
            <el-table-column label="自定义明度" prop="customVal"></el-table-column>
            <el-table-column label="自定义亮度" prop="customBri"></el-table-column>
            <el-table-column label="启用">
                <template v-slot="scope">
                    <span style="color:#36C626" v-if="scope.row.enable">是</span>
                    <span style="color:#FF1A2E" v-else>否</span>
                </template>
            </el-table-column>
        </el-table>

        <!-- 睡眠计划 -->
        <div class="section-header" style="margin-top:24px">
            <span class="section-title">睡眠计划</span>
            <el-button size="mini" class="btnClass" @click="loadSleepPlans">刷新</el-button>
        </div>
        <el-table :data="sleepPlans" size="mini" empty-text="暂无睡眠计划">
            <el-table-column label="序号" prop="index" width="60"></el-table-column>
            <el-table-column label="时间">
                <template v-slot="scope">
                    <span>{{ padTime(scope.row.hour) }}:{{ padTime(scope.row.minute) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="重复">
                <template v-slot="scope">
                    <span>{{ formatRepeatDays(scope.row.repeatDays) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="标签" prop="tag"></el-table-column>
            <el-table-column label="渐暗时长(分)" prop="fadeDuration"></el-table-column>
            <el-table-column label="自定义">
                <template v-slot="scope">
                    <span style="color:#36C626" v-if="scope.row.customize">是</span>
                    <span style="color:#FF1A2E" v-else>否</span>
                </template>
            </el-table-column>
            <el-table-column label="自定义色相" prop="customHue"></el-table-column>
            <el-table-column label="自定义饱和度" prop="customSat"></el-table-column>
            <el-table-column label="自定义明度" prop="customVal"></el-table-column>
            <el-table-column label="自定义亮度" prop="customBri"></el-table-column>
            <el-table-column label="启用">
                <template v-slot="scope">
                    <span style="color:#36C626" v-if="scope.row.enable">是</span>
                    <span style="color:#FF1A2E" v-else>否</span>
                </template>
            </el-table-column>
        </el-table>

        <!-- 定时器执行状态 -->
        <div class="section-header" style="margin-top:24px">
            <span class="section-title">定时器执行状态</span>
            <el-button size="mini" class="btnClass" @click="loadTimerStatus" :disabled="!device.running">刷新</el-button>
        </div>
        <div v-if="!device.running" style="color:#999;font-size:13px;margin-bottom:16px;">设备未运行，无法获取定时器状态</div>
        <template v-else>
            <div class="section-sub-title">计划执行状态</div>
            <el-table :data="timerPlanList" size="mini" empty-text="暂无计划执行状态">
                <el-table-column label="计划" prop="key" width="120"></el-table-column>
                <el-table-column label="类型" prop="slotType" width="100"></el-table-column>
                <el-table-column label="目标时间">
                    <template v-slot="scope">
                        <span>{{ padTime(scope.row.targetHour) }}:{{ padTime(scope.row.targetMinute) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="触发时间">
                    <template v-slot="scope">
                        <span>{{ padTime(scope.row.triggerHour) }}:{{ padTime(scope.row.triggerMinute) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="重复" prop="repeatDays" width="80"></el-table-column>
                <el-table-column label="跨天" width="60">
                    <template v-slot="scope">
                        <span style="color:#FF9900" v-if="scope.row.crossDay">是</span>
                        <span v-else>否</span>
                    </template>
                </el-table-column>
                <el-table-column label="渐变中" width="70">
                    <template v-slot="scope">
                        <span style="color:#36C626" v-if="scope.row.fading">是</span>
                        <span v-else>否</span>
                    </template>
                </el-table-column>
                <el-table-column label="上次触发" width="170">
                    <template v-slot="scope">
                        <span>{{ scope.row.lastTrigger || '-' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="下次触发" width="170">
                    <template v-slot="scope">
                        <span>{{ scope.row.nextTrigger || '-' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="启用" width="60">
                    <template v-slot="scope">
                        <span style="color:#36C626" v-if="scope.row.enable">是</span>
                        <span style="color:#FF1A2E" v-else>否</span>
                    </template>
                </el-table-column>
            </el-table>

            <div class="section-sub-title" style="margin-top:16px">倒计时状态</div>
            <el-table :data="timerCountdownList" size="mini" empty-text="暂无倒计时">
                <el-table-column label="通道" prop="key" width="80"></el-table-column>
                <el-table-column label="总时长(秒)" prop="D"></el-table-column>
                <el-table-column label="剩余时间(秒)" prop="RM"></el-table-column>
                <el-table-column label="状态" prop="S" width="80">
                    <template v-slot="scope">
                        <span style="color:#36C626" v-if="scope.row.S === 1">运行中</span>
                        <span style="color:#FF1A2E" v-else>已停止</span>
                    </template>
                </el-table-column>
                <el-table-column label="目标动作" prop="TA" width="80"></el-table-column>
                <el-table-column label="目标值" prop="TV" width="80"></el-table-column>
                <el-table-column label="启用" width="60">
                    <template v-slot="scope">
                        <span style="color:#36C626" v-if="scope.row.E">是</span>
                        <span style="color:#FF1A2E" v-else>否</span>
                    </template>
                </el-table-column>
            </el-table>
        </template>
    </div>
</template>
<script type="text/ecmascript-6">
export default {
    name: 'virtualdevicedetail',
    data() {
        return {
            device: {},
            propForm: {
                Switch: '',
                WorkMode: '',
                BrightnessNum: 0,
                ColorBrightnessNum: 0,
                ColorTempNum: 0,
                DoNotDisturb: '',
                PowerMemory: '',
                Color: ''
            },
            propLoading: false,
            schedules: [],
            wakeupPlans: [],
            sleepPlans: [],
            timerPlans: {},
            timerCountdowns: {}
        }
    },
    computed: {
        timerPlanList() {
            return Object.keys(this.timerPlans).map(key => ({
                key,
                ...this.timerPlans[key]
            }))
        },
        timerCountdownList() {
            return Object.keys(this.timerCountdowns).map(key => ({
                key,
                ...this.timerCountdowns[key]
            }))
        }
    },
    methods: {
        goback() {
            this.$router.push('/iot/virtualdevice')
        },
        padTime(n) {
            return String(n).padStart(2, '0')
        },
        formatRepeatDays(val) {
            if (!val) return '仅一次'
            if (val === 127) return '每天'
            if (val === 62) return '工作日'
            if (val === 65) return '周末'
            const days = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
            const result = []
            for (let i = 0; i < 7; i++) {
                if (val & (1 << i)) result.push(days[i])
            }
            return result.join('、')
        },
        loadDetail() {
            const uuid = this.$route.params.uuid
            this.api.VirtualDeviceDetail({ uuid }).then(res => {
                if (res.data.code == 200) {
                    this.device = res.data.data
                    this.loadSchedules()
                    this.loadWakeupPlans()
                    this.loadSleepPlans()
                    this.loadTimerStatus()
                    return
                }
                this.$message.error('获取详情失败：' + res.data.msg)
            })
        },
        setProperties() {
            const properties = {}
            if (this.propForm.Switch !== '') properties.Switch = +this.propForm.Switch
            if (this.propForm.WorkMode !== '') properties.WorkMode = +this.propForm.WorkMode
            properties.Brightness = this.propForm.BrightnessNum
            properties.ColorBrightness = this.propForm.ColorBrightnessNum
            properties.ColorTemp = this.propForm.ColorTempNum
            if (this.propForm.DoNotDisturb !== '') properties.DoNotDisturb = +this.propForm.DoNotDisturb
            if (this.propForm.PowerMemory) properties.PowerMemory = this.propForm.PowerMemory
            if (this.propForm.Color) properties.Color = this.propForm.Color
            if (Object.keys(properties).length === 0) {
                this.$message.warning('请至少设置一个属性')
                return
            }
            this.propLoading = true
            this.api.VirtualDeviceSetProperties({
                uuid: this.device.uuid,
                properties
            }).then(res => {
                this.propLoading = false
                if (res.data.code == 200) {
                    this.$message.success('属性设置成功')
                    return
                }
                this.$message.error('属性设置失败：' + res.data.msg)
            }).catch(() => { this.propLoading = false })
        },
        startDevice() {
            this.api.VirtualDeviceStart({ uuid: this.device.uuid }).then(res => {
                if (res.data.code == 200) {
                    this.$message.success('启动成功')
                    this.loadDetail()
                    return
                }
                this.$message.error('启动失败：' + res.data.msg)
            })
        },
        stopDevice() {
            this.$confirm('确定停止该虚拟设备？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.api.VirtualDeviceStop({ uuid: this.device.uuid }).then(res => {
                    if (res.data.code == 200) {
                        this.$message.success('停止成功')
                        this.loadDetail()
                        return
                    }
                    this.$message.error('停止失败：' + res.data.msg)
                })
            }).catch(() => { })
        },
        deleteDevice() {
            this.$confirm('确定删除该虚拟设备？删除后将清理所有关联数据。', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.api.VirtualDeviceDelete({
                    uuid: this.device.uuid,
                    uid: this.device.owner_uid
                }).then(res => {
                    if (res.data.code == 200) {
                        this.$message.success('删除成功')
                        this.$router.push('/iot/virtualdevice')
                        return
                    }
                    this.$message.error('删除失败：' + res.data.msg)
                })
            }).catch(() => { })
        },
        loadSchedules() {
            if (!this.device.device_id) return
            this.api.VirtualDeviceSchedules({ device_id: this.device.device_id }).then(res => {
                if (res.data.code == 200) {
                    this.schedules = res.data.data || []
                }
            })
        },
        loadWakeupPlans() {
            if (!this.device.device_id) return
            this.api.VirtualDeviceWakeupPlans({ device_id: this.device.device_id }).then(res => {
                if (res.data.code == 200) {
                    this.wakeupPlans = res.data.data || []
                }
            })
        },
        loadSleepPlans() {
            if (!this.device.device_id) return
            this.api.VirtualDeviceSleepPlans({ device_id: this.device.device_id }).then(res => {
                if (res.data.code == 200) {
                    this.sleepPlans = res.data.data || []
                }
            })
        },
        loadTimerStatus() {
            if (!this.device.uuid || !this.device.running) return
            this.api.VirtualDeviceTimerStatus({ uuid: this.device.uuid }).then(res => {
                if (res.data.code == 200) {
                    this.timerPlans = res.data.data.plans || res.data.data || {}
                    this.timerCountdowns = res.data.data.countdowns || {}
                }
            })
        }
    },
    mounted() {
        this.loadDetail()
    }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.container {
    font-family: 'Manrope';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    .section-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 12px;
    }
    .section-title {
        font-size: 16px;
        font-weight: 600;
        color: #000;
    }
    .section-sub-title {
        font-size: 14px;
        font-weight: 500;
        color: #333;
        margin-bottom: 8px;
    }
    .search {
        background: #F0F2F5;
        padding-top: 16px;
        margin-bottom: 24px;
    }
    .el-form {
        ::v-deep(.el-form-item__label) {
            font-family: 'Manrope';
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            color: #000000;
            opacity: 0.8;
            padding-right: 10px;
        }
        .el-form-item {
            margin-left: 24px;
        }
    }
    .btnClass {
        color: #FFF;
        background-color: #FB6D07;
        border-color: #FB6D07;
    }
    .slider-form {
        padding: 0 24px 16px 0;
        ::v-deep(.el-form-item) {
            margin-left: 24px;
            margin-bottom: 0;
        }
        ::v-deep(.el-form-item__label) {
            font-family: 'Manrope';
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            color: #000000;
            opacity: 0.8;
            padding-right: 10px;
            line-height: 40px;
        }
    }
    .slider-wrap {
        display: flex;
        align-items: center;
        width: 100%;
        .el-slider {
            flex: 1;
        }
        .slider-val {
            width: 40px;
            text-align: center;
            margin-left: 12px;
            font-size: 14px;
            color: #000;
        }
    }
    .device-info {
        background: #F0F2F5;
        padding: 16px 24px;
        margin-bottom: 24px;
        border-radius: 4px;
        .info-item {
            margin-bottom: 12px;
        }
        .info-label {
            display: inline-block;
            width: 70px;
            color: #000;
            opacity: 0.5;
            margin-right: 8px;
        }
        .info-value {
            color: #000;
            opacity: 0.8;
            word-break: break-all;
        }
    }
    ::v-deep(thead) {
        font-family: 'Manrope';
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        color: #000;
        opacity: 0.8;
        th {
            font-weight: 400;
            background-color: #F0F2F5;
        }
    }
    ::v-deep(tbody) {
        tr {
            font-family: 'Manrope';
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            color: #000000;
            opacity: 0.8;
        }
    }
}
</style>